<template>
<div>
  <layout-header></layout-header>
  <div class="layout-content">
    <div class="layout-top-line"></div>
    <h3 class="about-us-title">关于我们</h3>
    <div class="about-us-content">
      <div class="paragraph">皇家加勒比集团是全球领先的国际游轮集团，旗下拥有五个屡获殊荣的全球游轮度假品牌，包括皇家加勒比国际游轮、名人游轮（另被称做精致游轮）、银海游轮、途易游轮和赫伯罗特游轮，船队规模为63艘游轮，航线涵盖1000个世界目的地。目前，皇家加勒比集团有11艘新船在建造中。</div>
      <div class="paragraph">媒体垂询，请邮件至chinaprdesk@rcclapac.com</div>
    </div>
  </div>
</div>
</template>

<script>
import LayoutHeader from "@/layout/MediaCenter/components/LayoutHeader";
export default {
  name: "AboutUs",
  components: {LayoutHeader}
}
</script>

<style lang="less" scoped>
.about-us-title {
  font-size: 1.22rem;
  margin-top: 47px;
  
  color: #00168b;
}
.about-us-content {
  & .paragraph {
    font-size: .82rem;
    margin-top: 30px;
    line-height: 1.8;
    color: #545a6f;
  }
}
</style>
